/**
 * an-ads plugins
 */
import '../plugins/slots/slot-controller'
import '../plugins/account'
import '../plugins/cmpConfig'
import '../plugins/debug'
import '../plugins/refresh-info'
import '../plugins/peekaboo'
import '../plugins/positions-monitor'
import '../plugins/overlay-detector'

/**
 * dmg-ads common
 */
import '@mailonline/dmg-ads-core/src/common/plugins/cmp'
import '@mailonline/dmg-ads-core/src/common/plugins/gpt'
import '@mailonline/dmg-ads-core/src/common/plugins/slots/conditional-load'
import '@mailonline/dmg-ads-core/src/common/plugins/slots/lazyLoad'
import '@mailonline/dmg-ads-core/src/common/plugins/runtime-messages'
import '@mailonline/dmg-ads-core/src/common/plugins/slots/refresh/refreshManager'
import '@mailonline/dmg-ads-core/src/common/plugins/expose-ads-data'
import '@mailonline/dmg-ads-core/src/common/plugins/analytics/impressions.banner'
import '@mailonline/dmg-ads-core/src/common/plugins/analytics'
import '@mailonline/dmg-ads-core/src/common/plugins/userId'

/**
 * dmg-ads plugins
 */
import '@mailonline/dmg-ads-core/src/plugins/tcfv2-v2'
import '@mailonline/dmg-ads-core/src/plugins/analytics/core-metrics'
import '@mailonline/dmg-ads-core/src/plugins/analytics/loaf'
import '@mailonline/dmg-ads-core/src/plugins/analytics/time-spent'
import '@mailonline/dmg-ads-core/src/plugins/analytics/page-unload'
import '@mailonline/dmg-ads-core/src/plugins/analytics/page-meta'
import '@mailonline/dmg-ads-core/src/plugins/analytics/partners'
import '@mailonline/dmg-ads-core/src/plugins/trackers/browsersResolution'
import '@mailonline/dmg-ads-core/src/plugins/trackers/watchdog'
import '@mailonline/dmg-ads-core/src/plugins/trackers/visits'
import '@mailonline/dmg-ads-core/src/plugins/gcm'
import '@mailonline/dmg-ads-core/src/plugins/scroll-observer'

/**
 * dmg-ads plugins-ng
 */
import '@mailonline/dmg-ads-core/src/ads-tracking/plugins-ng/script-loader'
import '@mailonline/dmg-ads-core/src/ads-tracking/plugins-ng/sessionDepth'

export { default as analyticsBidmaxSendBeacon } from '@mailonline/dmg-ads-core/src/plugins/analytics/bidmaxSendBeacon'
export { default as analyticsBidmaxSendBeaconMigration } from '@mailonline/dmg-ads-core/src/plugins/analytics/bidmaxSendBeaconMigration'

export { default as analyticsViewability } from '@mailonline/dmg-ads-core/src/plugins/analytics/viewability'
export { default as analyticsMemory } from '@mailonline/dmg-ads-core/src/plugins/analytics/memory'
export { default as analyticsStorage } from '@mailonline/dmg-ads-core/src/plugins/analytics/storage'
export { default as analyticsRtaIds } from '@mailonline/dmg-ads-core/src/plugins/analytics/rta-ids'
export { default as analyticsExternalData } from '@mailonline/dmg-ads-core/src/plugins/analytics/external-data'
export { default as analyticsTiming } from '@mailonline/dmg-ads-core/src/plugins/analytics/timing'
export { default as analyticsCMP } from '@mailonline/dmg-ads-core/src/plugins/analytics/cmp'
export { default as revenueReporter } from '@mailonline/dmg-ads-core/src/plugins/revenue-reporter'
